require(`@rails/ujs`).start()
require(`turbolinks`).start()

require.context(`../../images`, true)
import "../../stylesheets/application.scss"
import "../application"
